// Playing the game again as someone who has never seen it (admins and test
// accounts, from Settings). Two ways:
//
//  - A test account (an admin's address with a "+tag", core shop/admins.js)
//    starts over: the server deletes everything kept about it, then this device
//    forgets its local data too, and the page starts again signed in.
//  - A fresh guest: sign out and forget this device's data, as a first visit.
import { supabase } from "./supabase";
import { dsHttpOrigin } from "../online/net";

// Forget everything this site keeps in the browser. `keepSession` leaves the
// sign-in (Supabase's sb-<ref>-auth-token) so a reset test account stays in.
export function forgetThisDevice(keepSession: boolean): void {
  try {
    for (const key of Object.keys(localStorage)) {
      if (keepSession && /^sb-.*-auth-token$/.test(key)) continue;
      localStorage.removeItem(key);
    }
  } catch { /* no storage */ }
  try { sessionStorage.clear(); } catch { /* no storage */ }
}

export async function resetTestAccount(): Promise<{ ok: true } | { error: string }> {
  if (!supabase) return { error: "unconfigured" };
  let token: string | null = null;
  try { token = (await supabase.auth.getSession()).data.session?.access_token ?? null; } catch { token = null; }
  if (!token) return { error: "not_signed_in" };
  try {
    const res = await fetch(`${dsHttpOrigin()}/api/test-account/reset`, { method: "POST", headers: { authorization: `Bearer ${token}` } });
    const body = await res.json().catch(() => ({}));
    if (!res.ok || !body.reset) return { error: body.error || "failed" };
  } catch {
    return { error: "network" };
  }
  forgetThisDevice(true);
  window.location.assign("/");
  return { ok: true };
}

export async function startAsFreshGuest(): Promise<void> {
  try { if (supabase) await supabase.auth.signOut(); } catch { /* signed out anyway below */ }
  forgetThisDevice(false);
  window.location.assign("/");
}
